import type { CountryRequiresWhatsappStatus } from './country-requires-whatsapp.model';

export interface GenerateCountryRequiresWhatsappOptions {
  readonly id: string;
  readonly countryRequiresWhatsapp: boolean;
  readonly countryOffersWhatsapp?: boolean;
}

export function generateCountryRequiresWhatsappObject({
  id = 'PH',
  countryRequiresWhatsapp = true,
  countryOffersWhatsapp = false,
}: GenerateCountryRequiresWhatsappOptions): CountryRequiresWhatsappStatus {
  return {
    id,
    countryRequiresWhatsapp,
    countryOffersWhatsapp,
  };
}
